<template>
    <div class="modal fade" id="selectForecastModel" tabindex="-1" role="dialog" aria-labelledby="selectForecastModelTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="selectForecastModelTitle">Select forecast to open</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="this.$store.state.forecastInventory != null" class="modal-body">
                    <label for="country-list">Country/area:</label>
                    <select id="country-list" class="form-control" v-model="selCountry">
                        <option v-for="item in this.$store.state.forecastInventory.items" 
                                :key="item.country.countryID" 
                                :value="item.country.countryID">{{ item.country.name }}</option>
                    </select>                                    

                    <template v-if="inventoryItem != null">
                        <label for="forecast-list">Forecasts for {{ inventoryItem.country.name }}:</label>
                        <div class="select-forecast-list">
                            <a v-for="forecast in inventoryItem.forecasts" 
                                    href="#"
                                    class="select-forecast-list-item"
                                    :key="forecast.forecastID.toString()"                                    
                                    :class="{active: forecast == selForecast}"
                                    :data-forecastID="forecast.forecastID.toString()" 
                                    @click="forecastClicked"><strong>{{ forecast.forecastID.toString() }}</strong> published {{ forecast.pubDate.toDateString() }}</a>
                        </div>                        
                    </template>

                    <template v-if="inventoryItem != null">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="always-load" v-model="alwaysLoad">
                            <label class="form-check-label" for="always-load">Always load the latest forecast for {{ inventoryItem.country.name }}</label>
                        </div>                        
                    </template>

                </div>
                <div class="modal-footer">
                    <button :disabled="selForecast == null" type="button" class="btn btn-primary" @click="okClicked">Open</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import $ from '@/lib/JQuery.js'
import DateUtils from '@/lib/DateUtils.js'
import events from '@/lib/events.js'
import logger from '@/lib/logger.js'
import { ForecastListItem } from '@/lib/Forecast.js'
import { ServiceController } from '@/lib/ServiceController.js'

export default {
    name: 'SelectForecastDialog',
    data() {
        return {
            selCountry: '',
            selForecast: null,
            alwaysLoad: false
        }
    },
    computed: {
        inventoryItem() {
            return this.$store.state.forecastInventory.items.find((item) => item.country.countryID == this.selCountry)
        },
    },
    watch: {
        selCountry(newVal, oldVal) {
            logger.log('watch SelectForecastDialog::selCountry()', { newVal: newVal, oldVal: oldVal })
            if (newVal != oldVal) {
                let latestForecast = this.getLatestForecastForCountry(newVal)                                
                
                logger.log('Setting selForecast', latestForecast)
                this.selForecast = latestForecast
            }
        }
    },
    methods: {
        getLatestForecastForCountry(countryID) {
            if (countryID != null) {
                let forecasts = this.$store.state.forecastInventory.items.find((item) => item.country.countryID == countryID)
                if (forecasts != null && forecasts.forecasts.length > 0)
                    return forecasts.forecasts[0]
            }
            
            return null
        },
        show() {
            $(this.$refs.modal).modal('show')
        },
        getSelectedAutoLoadCID() {
            return this.alwaysLoad ? this.selCountry : ''
        },
        updateConfig() {
            let autoLoadCID = this.getSelectedAutoLoadCID()
            if (this.$store.state.userConfig.autoLoadCID != autoLoadCID)
                ServiceController.updateConfigProperty('autoLoadCID', autoLoadCID)
        },
        forecastClicked(e) {
            logger.log('SelectForecastDialog::forecastClicked')
            
            let forecastID = e.target.dataset.forecastid            
            
            let forecast = this.inventoryItem.forecasts.find((item) => item.forecastID.toString() == forecastID)
            if (forecast == null)
                logger.log('Unable to find forecast')
            else
                logger.log('Found forecast', forecast)
            
            this.selForecast = forecast
        },
        okClicked() {
            if (this.selForecast != null) {
                logger.log('Setting forecast x', this.selForecast)
                this.$store.commit('setForecast', this.selForecast)
                $(this.$refs.modal).modal('hide')

                this.updateConfig()
            }       
        }
    }
}
</script>

<style>

.modal-body {
    display: flex;
    flex-direction: column;
}

.select-forecast-list {
    overflow-y: auto;
    border: 1px solid #ddd;
    max-height: 30vh;
}

.select-forecast-list-item {
    display: block;
    position: relative;
    padding: 0.5em;    
}

.select-forecast-list-item.active {
    background-color: dodgerblue;
    color: white;
}

</style>
